import type { VolumeAutocompleteField } from '~/shared/components/filters/search/common/volumeAutocomplete';

/** Keys safe for DOM ids — avoid autofill-triggering tokens (name, card, number, cc). */
export const volumeAutocompleteFieldToSearchKey: Record<VolumeAutocompleteField, string> = {
  clusterName: 'cluster',
  instanceId: 'instance',
  volumeId: 'volume',
  nodeGroupName: 'node-group',
  region: 'region',
  diskType: 'volume-type',
};

/** Exploration checkbox sections that render a section-level SearchBar. */
export type ExplorationSearchSectionId =
  | 'cluster'
  | 'nodeGroup'
  | 'instanceId'
  | 'volumeId'
  | 'tags';

export const explorationSectionIdToSearchKey: Record<ExplorationSearchSectionId, string> = {
  cluster: 'cluster',
  nodeGroup: 'node-group',
  instanceId: 'instance',
  volumeId: 'volume',
  tags: 'volume-tags',
};

export const volumeFilterSearchScope = 'volume-filter';

export function buildSearchInputId(scope: string, key: string): string {
  return `${scope}-search-${key}`;
}

export function explorationSearchInputId(sectionId: ExplorationSearchSectionId): string {
  return buildSearchInputId('exploration', explorationSectionIdToSearchKey[sectionId]);
}

export function volumeFilterSearchInputId(key: string): string {
  return buildSearchInputId(volumeFilterSearchScope, key);
}

export function isExplorationSearchSectionId(id: string): id is ExplorationSearchSectionId {
  return id in explorationSectionIdToSearchKey;
}

/** Human-readable search label for filter sections — not used as a DOM id. */
export function buildFilterSearchAriaLabel(sectionTitle: string): string {
  const normalized = sectionTitle.trim();
  if (/\bID$/i.test(normalized)) {
    const base = normalized.replace(/\s+ID$/i, '');
    return `Search ${base.toLowerCase()} IDs`;
  }
  return `Search ${normalized.toLowerCase()}`;
}
